/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import config from "../config/graph.config.json";
  
  export interface IGraphMethods extends IPluginMethodMap {
    getGraphProps(args: any): Promise<any>;
  }
  
  export class GraphService implements IAgentPlugin {
    readonly methods: IGraphMethods;
  
    constructor() {
      this.methods = {
        getGraphProps: this.getProps.bind(this),
      };
    }
  
    async getProps(args: any) {
      return { ...(config || {}) };
    }
  }
  